import { Component, Input } from "@angular/core";
import { IPriceRange } from "src/app/components/lootboxes/lootbox.interface";
import { convertNumToCurr } from "../../constants/app-enums";

@Component({
  selector: "app-range-bar",
  templateUrl: "./range-bar.component.html",
  styleUrls: ["./range-bar.component.scss"],
})
export class RangeBarComponent {
  @Input({ required: true }) rangeData!: IPriceRange;
  @Input() hasBigFont: boolean = false;

  getWidth(): string {
    const percentage =
      (100 * (this.rangeData?.currentPrice - this.rangeData.minPrice)) /
      (this.rangeData.maxPrice - this.rangeData.minPrice);
    if (!percentage) {
      return "";
    }
    return `calc(${percentage}% + 10px)`;
  }

  convertNumToCurr(num: number) {
    return convertNumToCurr(num);
  }
}
